<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>系统信息
      <i class="el-icon-arrow-right"></i>&nbsp;课程列表
    </div>

    <section class="content_wrapper">
      <el-table
        :data="tableData.data"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column
          prop="no"
          label="课程编号"
          width="160">
        </el-table-column>
        <el-table-column
          prop="name"
          label="课程名称"
          width="250">
        </el-table-column>
        <el-table-column
          prop="originalPrice"
          label="课程原价"
          width="250">
        </el-table-column>
        <el-table-column
          prop="realPrice"
          label="课程实价"
          width="250">
        </el-table-column>

        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button @click="openUpdateDialog(scope.row)" type="text" size="small">修改</el-button>
<!--            <el-button @click="dialogFormVisible = true" type="text" size="small">修改</el-button>-->
          </template>
        </el-table-column>

      </el-table>

    </section>

    <el-dialog title="课程信息修改" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form">
        <el-form-item label="课程序号" :label-width="formLabelWidth">
          <el-input v-model.number="form.sortNo" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="课程名称" :label-width="formLabelWidth">
          <el-input clearable v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="课程原价" :label-width="formLabelWidth">
          <el-input v-model.number="form.originalPrice" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="课程实价" :label-width="formLabelWidth">
          <el-input v-model.number="form.realPrice" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="课程简介" prop="desc">
          <el-input clearable :rows="6" type="textarea" v-model="form.shortDesc"></el-input>
        </el-form-item>

        <el-form-item label="课程详介" prop="desc">
          <el-input clearable :rows="16" type="textarea" v-model="form.longDesc"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdate">确 定</el-button>
      </div>
    </el-dialog>

  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import {
  reqFindAllCourse4Admin,
  reqUpdateCourse
} from '@/api'

export default {
  name: 'AllCourses',

  data() {
    return {
      tableData: {},
      loading: true,
      dialogFormVisible: false,
      form: {
        id: 0,
        no: 0,
        sortNo: 0,
        name: '',
        originalPrice: 0,
        realPrice: 0,
        shortDesc: '',
        longDesc: ''
      },
      formLabelWidth: '120px',
      formData: '',
    }
  },

  async mounted() {
    await this.findAllCourse4Admin()
  },

  methods: {
    async findAllCourse4Admin() {
      const result = await reqFindAllCourse4Admin()
      if (result.code === 0) {
        this.tableData = result
        this.loading = false
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    openUpdateDialog (row) {
      this.form.id = row.id
      this.form.no = row.no
      this.form.sortNo = row.sortNo
      this.form.name = row.name
      this.form.originalPrice = row.originalPrice
      this.form.realPrice = row.realPrice
      this.form.shortDesc = row.shortDesc
      this.form.longDesc = row.longDesc
      this.dialogFormVisible = true
    },

    async submitUpdate () {
      if (!this.form.sortNo) {
        this.$message({message: '请输入课程排序序号', type: 'error'})
        return
      }
      if (!this.form.name.trim()) {
        this.$message({message: '请输入课程名称', type: 'error'})
        return
      }
      if (!this.form.originalPrice) {
        this.$message({message: '请输入课程原价', type: 'error'})
        return
      }
      if (!this.form.realPrice) {
        this.$message({message: '请输入课程实际价格', type: 'error'})
        return
      }
      if (!this.form.shortDesc.trim()) {
        this.$message({message: '请输入课程简介', type: 'error'})
        return
      }
      if (!this.form.longDesc.trim()) {
        this.$message({message: '请输入课程详细介绍', type: 'error'})
        return
      }

      this.formData = new FormData()
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.formData.append('id', this.form.id)
      this.formData.append('no', this.form.no)
      this.formData.append('sortNo', this.form.sortNo)
      this.formData.append('name', this.form.name.trim())
      this.formData.append('originalPrice', this.form.originalPrice)
      this.formData.append('realPrice', this.form.realPrice)
      this.formData.append('shortDesc', this.form.shortDesc.trim())
      this.formData.append('longDesc', this.form.longDesc.trim())

      const loading = this.$loading({
        lock: true,
        text: '提交中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      const result = await reqUpdateCourse(this.formData, config)
      loading.close()

      if (result.code === 0) {
        this.$refs.form.resetFields()
        this.$message({message: '课程信息更新成功', type: 'success'})
        await this.findAllCourse4Admin()
        this.dialogFormVisible = false
      } else {
        this.$message({message: '课程信息更新失败', type: 'error'})
      }

    }
  },

  computed: {}

}
</script>

<style scoped>

main {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.content_wrapper {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

.search_bar {
  width: 800px;
  margin: 20px auto;
}

.search_result_tip {
  color: #909399;
  font-size: 14px;
  line-height: 50px;
}

.btn {
  width: 140px;
  margin: 20px auto;
}

.path {
  height: 40px;
  line-height: 40px;
  padding-left: 16px;
  font-size: 14px;
  color: #666;
}

</style>



// WEBPACK FOOTER //
// src/pages/AdminCenter/AllCourses/AllCourses.vue